import { faFileAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, lighten, Skeleton, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { CurrentUserDocumentToSignSummaryDTO } from "../../../../models/document-to-sign/current-user-document-to-sign-summary/current-user-dcument-to-sign-summary-dto";

const ManageDocumentSignatureLink = ({
  customSummary,
  loading,
}: {
  customSummary: CurrentUserDocumentToSignSummaryDTO;
  loading: boolean;
}) => {
  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const tRP = "components.custom_widget_links.document_signature";
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      {currentUserAuthorizations?.canAccessDocumentToSign?.asManager ||
      currentUserAuthorizations?.canChangeAll ||
      currentUserAuthorizations?.canViewAll ? (
        <Grid
          style={{
            display: "flex",
            border: `1px solid ${theme.palette.primary.light}`,
            borderRadius: "8px",
            padding: "15px",
            color: theme.palette.primary.main,
            backgroundColor: lighten(theme.palette.primary.light, 0.8),
            position: "relative",
            gap: "5px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              color: theme.palette.primary.main,
              fontSize: "28px",
            }}
          >
            {loading ? (
              <Skeleton
                width={"40px"}
                height={"100%"}
                variant="rectangular"
              />
            ) : (
              customSummary.myRequests ?? 0
            )}
          </Typography>
          <Typography>{`${t(`${tRP}.manager_note`)}`}</Typography>

          <Grid
            style={{
              display: "flex",
              borderRadius: "20px",
              color: theme.palette.primary.contrastText,
              backgroundColor: lighten(theme.palette.primary.main, 0.4),
              position: "absolute",
              right: "12px",
              justifyContent: "center",
              alignItems: "center",
              top: "-17px",
              fontSize: "20px",
              width: "35px",
              height: "35px",
            }}
          >
            <FontAwesomeIcon icon={faFileAlt} />
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default ManageDocumentSignatureLink;
